import { components } from "./schema-lending";
import { components as aoApiComponents } from "./schema-ao-api";
import { components as publicApiComponents } from "./schema-public-api";

export type { paths as LendingPaths } from "../types/schema-lending";
export type { paths as AoApiPaths } from "../types/schema-ao-api";
export type { paths as PublicApiPaths } from "../types/schema-public-api";

export type Institution = publicApiComponents["schemas"]["InstitutionContextProcessor"];
export type ConsumerApplication = aoApiComponents["schemas"]["ConsumerApplication"];
export type LendingSidebarPromotion = publicApiComponents["schemas"]["LendingSidebarPromotion"];

export type IncomeTypeEnum = components["schemas"]["IncomeTypeEnum"];
export type MlaStatusEnum = components["schemas"]["MlaStatusEnum"];
export type StateEnum = components["schemas"]["State0e9Enum"];
export type Membership = components["schemas"]["Membership"];
export type MembershipRequirementResponse =
  components["schemas"]["CheckMembershipRequirementResponse"];
export type MembershipSelectionRequest = components["schemas"]["MembershipSelectionRequest"];
export type MembershipSharePrimaryEmailRequest = {
  email: string;
};
export type MembershipSelectionPayload =
  | Required<Pick<MembershipSelectionRequest, "core_user_id">>
  | { create_new_membership: true };
export type MembershipSelectionResponse = MembershipRequirementResponse;
export type MembershipShareAccessResponse = components["schemas"]["MembershipShareAccessResponse"];
export type MembershipAccountApplicationAuthenticationRequiredResponse =
  components["schemas"]["MembershipAccountApplicationAuthenticationRequiredResponse"];
export type LendingApplicantIncomeDetails = components["schemas"]["ApplicantIncomeDetails"];
export type ApplicationApplicantDetailsRead =
  components["schemas"]["ApplicationApplicantDetailsRead"];
// The nested (primary/additional applicant) and standalone applicant-details
// responses now share one backend serializer, so this is the same shape.
export type LendingApplicationApplicantDetails = ApplicationApplicantDetailsRead;
export type ApplicantDetailsAddressType = components["schemas"]["Address"];
export type AddressFormData = {
  residential_address: ApplicantDetailsAddressType;
  mailing_address: ApplicantDetailsAddressType;
  hasSameMailingAddress: boolean;
};
export type PersonalLoanOffer = components["schemas"]["PersonalLoanOffer"];
export type VehicleLoanOffer = components["schemas"]["VehicleLoanOffer"];
export type CreditCardOffer = components["schemas"]["CreditCardOffer"];
export type CreditCardProduct = components["schemas"]["CreditCardProduct"];
export type CreditCardApplication = components["schemas"]["CreditCardApplication"];
export type PersonalLoanApplication = components["schemas"]["PersonalLoanApplication"];
export type VehicleLoanApplication = components["schemas"]["VehicleLoanApplication"];
export type Csrf = components["schemas"]["Csrf"];
export type ApplicantSensitiveData = components["schemas"]["ApplicationApplicantDetailsSensitive"];
export type ApplicationRelationshipEnum = components["schemas"]["ApplicationRelationshipEnum"];

export const APPLICATION_RELATIONSHIP = {
  PRIMARY: "primary",
  CO_APPLICANT: "co_applicant",
} as const satisfies Record<string, ApplicationRelationshipEnum>;

export type PrefillDataSourceEnum = components["schemas"]["PrefillDataSourceEnum"];

export const PREFILL_DATA_SOURCE = {
  PLAID_LAYER: "PLAID_LAYER",
  MANUAL: "MANUAL",
} as const satisfies Record<string, PrefillDataSourceEnum>;
